interface AiAssistantIconProps {
  className?: string;
  size?: number;
}

export default function AiAssistantIcon({ className = "", size = 24 }: AiAssistantIconProps) {
  return (
    <img
      src="/ai-assistant.png"
      alt="AI Assistant"
      width={size}
      height={size}
      className={`relative cursor-default overflow-hidden rounded-full bg-gradient-to-br from-yellow-300 to-yellow-200 transition-transform duration-200 hover:scale-105 ${className}`}
    />
  );
}
